<template>
    <div class="qsgy-footer">
        <div class="uniform_info">
            <!-- <div class="minzhengbu">
                <div class="left">
                    <img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAAwCAMAAACCABLMAAAAqFBMVEUAAADuJSXuJCTuJSXtJCT9JyfwJyftJSXuJCT/Ly/uJCTuJCTuJSX/PT3uJSXuJSXuJyfzJyfuJCTuJCTuJCTuJSXuJSXyKSn/LS3uJCTuJSX0KyvuJCTuJCTuJCTwJibvJyfwLi7uJSXuJSXvJCTvJibuJibxJyfvKSnuJCTtJCTwJSXyKCjtJSXtJSXuJCTuJCTtJSXwJyfuJSXtJSXuJSXuJSXtJCSAh+QRAAAAN3RSTlMAaprr6A40nvEH49SnBPtVOxvOspaKcyUL+FkW27d3MS0QvY5uUEoqH8asRBL0yqKSgkHdyXpkl+3n2gAAAi1JREFUSMftlemSokAMgMOoo4CNXCpyiPcxnuscef8328SWdRBo8f9+VVJUqr8iSXdayFi34AUmkKHFw9qWaL/dPWzYNbXWDH97OOrV0jYm5jxiUENLDSx46Itn2uqAJR4mgVrTLCz10HVUWh+xwkNjUmnpH1jqnT851mlX4SJhjQueFn3hMw6rVtGDwEM1RgplHsBcqZkOVHgweVcQQKWn5r/3sie0rn8prF6+tUOlJ7ZIjB80n4MfKm+AjJW/pS54pafwErnkJ+f9kUFf4d1mLMx5YxmcK7wQmU6Uv2ctZGyFBz5rS8ijjajmb/X+vQ9+HHmbdBnZ2qG2mMCDp9u9HVf+bYeXAO50ZVFV+77o4J1RX4cMMTYw1qDcm84eZ3ooE/ci2kzesk3SK/FOSGRfbPBje0tyq1+9qYnzorei52wIwYIa1t+Dc8r+JjYdipOXHtHYF72EEtOvXTzvgPEQY2DsJuXBmXxOoOg1uf1isZJLBwHsKNwCxvEPnHp/CiUepbeEEEfcjGkHx7CmsAMSfb0bivJ+xlQW2IhdeXeGfAAs8XxufUQjAJeq9L/oVefXBFQ4Vy9F/uDGkKc5hYUcMwVLNq5zY9mwPxtotB1YU/9cpaab8iQ7tLK54QD9IgPRShWWsF0k1reBM2XngyOS11QwQsb7dwkcp7wPW6xFvL/PixtB5NbTZlFWasKpajF3tKGmaZ5Wv3rkocTT4SWEHO22gFfpeaa3hNr8BcA7o7I49MIlAAAAAElFTkSuQmCC">
                    <span class="name">
                        <h3>民&nbsp;政&nbsp;部&nbsp;指&nbsp;定&nbsp;的</h3>
                        <h3>互联网募捐信息平台</h3>
                    </span>
                </div>
                <div class="middle"></div>
                <div class="right">
                    <h3>统一社会信用代码：</h3>
                    <h3>91110101317962611U</h3>
                </div>
            </div> -->

            <!-- <div class="footer_log">
                <div class="left">
                    <img
                        src="data:image/png;base64,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">
                </div>
                <div class="middle">
                    <img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAkCAMAAABR74GsAAAANlBMVEUAAADq6urq6urf39/l5eXn5+fq6upVqqrp6enY2Njq6urp6enq6urp6enp6enl5eXm5ubq6uqx9UT7AAAAEXRSTlMAusEPExjIA7AN8qMkmIwxKOqmjPIAAABxSURBVCjP5c5LEoMwDATRQcjIMeTj+182LlKhMezZ0Du9hWp0w17Zu/sxP0PKdfA9DtWauq0MTkn68XhAGOx5BGFQ8AcUXKo17FtKLcsR28/CQNDe7AZdCQalNG0MwmDPDsLxRziHYs4rwtb0XIDX9AUnhQSbqoHnJAAAAABJRU5ErkJggg==">
                </div>
                <div class="right">
                    <img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAkCAMAAABIZG8KAAAAeFBMVEUAAAD1qx/1qh/1qiD1qh/1rCD0qx//vyr0qx/5riL2rB/0qyD/qyD3qiD3qiH2rSL8qCP1qx/1qyD0qyD1qh/1qh/1qyD1qx/1qx/1qyH1qyD2qh70qx/1qyD2qx/3qyH3qif0qiD/mTP1rCD1qiH1qyL1qx/1qh81kwjzAAAAJ3RSTlMA9+HQxoy9BtYocMIPP0UzGOe4j3qzoKubhYBT762jPSFgCpZmTMy0udpnAAACY0lEQVRIx+3V6XKiQBiF4dPQrLILikoSjcu5/zscGvKJRoiV1JCqqZrnR6sU+rJ0I+Zzxi94wS9IMaf3IoOIqgzz2Md4L9fr9SZCGmA2aRGbsYoxn6h4h+FVGWazkZseHDGbl7nn8WEd3Pz0Gtm6BKJN4baq1EyL40J36k+TQi/GD9V12yHLDzAid/JMKirLsnI67d4NG8vIqfa4ReIOt9ft+8Tha2JcOHlPlIraMeQOOMl3EX6808v7iKPlc0t323Neqc+zCzK7aJnRVu1mh5HsplYfp5ncRt5YoeN/RIoCSdgw7O1u1smbrJMhkrKGiXjXyGu/dpXvDRHPV3s8iGiPrPitrPghsmIwGkHJ7RDZssQ97QAJa8RVNPHsKjKJZKrAaMQcfCCRQNke7nFh0gcs+YZBv5dMUIlsmExEENOVKewyxUik4CleM4zjOBud5hLJLUxFsHTlnetAaBpuF7EorPF/Rok0+7HINEdTab3pIklZlpp1OyYYI5EzdR/xBduI5hiNjrLkcrXknnwZwYZhF1GCK6C2O4r9K1X3Uv844vmNd3+5VhCNhQ7l5vw0ggPPE5GY9WMkCdmEYWwioW7l9NvReRKJzKJbjkWOPD9GchqWiRyVQTNUTyIBSxPBQyRqcu8xEuxUvtsF37pcp03OdDzitPW/ck8C0tphNJKaJ+TzyCHPnp5Jln1e8ewjkcUYX0U0xLOICHlAb8dt17jQgegflcKm+eQz+G4kULS1YbP/8oI1rg6k3XLkMJR22pH24Igp7gpXsVY01CWBceka4uQrkoWcdk7dbrM40PjvX/EH7uY94a59x3YAAAAASUVORK5CYII=">
                </div>
            </div> -->
        </div>
        <div class="footer-copyright">
            <div class="container">
                <div class="guide">
                    <!-- <div class="list">
                        <p>项目投诉：<a @click="dialogFormVisible = true">点击举报</a></p>
                        <el-dialog title="举报反馈" :visible.sync="dialogFormVisible" width="600px" custom-class="qsgy-dialog">
                            <div class="title">欢迎大家监督举报，让每一笔捐款能帮助到真正有需要的人，轻松公益将严格保护举报人的信息安全。</div>

                            <div class="item-group">
                                <el-input type="textarea" :rows="5" placeholder="请填写举报内容（不超过300字）"
                                    v-model.trim="formData.content" class="textarea-bt-38">
                                </el-input>
                            </div>

                            <div class="item-group">
                                <div class="label">上传举报相关照片 </div>
                                <uploader
                                    ref="imgUploader"
                                    :max-num="1"
                                    button-id="images_uploader"
                                    :user-imgs="formData.images"
                                    @change="onReportImgChange" />
                                <div class="topic">*图片内容必须清晰可见以保证真实性</div>
                            </div>

                            <div slot="footer" class="dialog-footer">
                                <el-button @click="dialogFormVisible = false">取 消</el-button>
                                <el-button type="danger" @click="submit">提 交</el-button>
                            </div>
                        </el-dialog>
                    </div> -->
                    <span>© 北京领航起源科技有限公司 &nbsp;<a href='http://beian.miit.gov.cn'>京ICP备2024084995号-1</a></span>
                </div>
                <!-- <div class="service">gongyi@qingsongchou.com<p>联系邮箱</p>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import Uploader from "./uploader/index"

export default {
  name: "",
  components: {
    Uploader,
  },
  data() {
    return {
      dialogFormVisible: false,
      dialogVisible: false,
      formData: {
        content: "",
        images: [],
        project_no: "",
      },
      isSubmit: false,
      formLabelWidth: "120px",
    }
  },
  methods: {
    submit() {
      if (this.contentError) return
      const query = this.$route.query
      if (query && query.id) {
        this.formData.project_no = query.id
      }
      const { content, images } = this.formData
      if (!content || content.length < 10) {
        this.$message({
          message: "请输入正确的举报内容,不少于10个字",
          center: true,
          duration: 3000,
          type: "error",
        })
        return
      }
      if (content.length > 300) {
        this.$message({
          message: "请输入正确的举报内容（不超过300字",
          center: true,
          duration: 3000,
          type: "error",
        })
        return
      }
      if (!images || !images.length) {
        this.$message({
          message: "请上传举报相关照片",
          center: true,
          duration: 3000,
          type: "error",
        })
        return
      }

      if (this.isSubmit) return
      this.isSubmit = true

      const url = `https://partner-gateway.qschou.com/official/report/pc/submit`
      const formData = this.formData
      axios
        .post(url, formData)
        .then((res) => {
          let data = res.data
          this.isSubmit = false

          if (data.code !== 0) {
            this.$message({
              message: res.message,
              type: "error",
            })
            return
          }

          this.$message({
            duration: 2000,
            message: "提交成功",
            type: "success",
          })

          this.formData.content = ""
          this.$refs.imgUploader.deleteImageAt(0)
          this.dialogFormVisible = false
        })
        .catch(() => {
          this.isSubmit = false
        })
    },
    onReportImgChange(images) {
      this.formData.images = images
    },
  },
}
</script>

<style lang="less">
.qsgy-footer {
  background: #f7f9fa;
  border-top: 1px solid #f7f9fa;

  .uniform_info {
    margin: 0 auto;
    padding-bottom: 30px;

    .minzhengbu {
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;
      margin: 35px auto 30px;

      .left {
        flex: 0 0 40%;
        text-align: right;

        .name {
          display: inline-block;
          text-align: left;

          h3 {
            font-size: 12px;
            font-weight: 600;
            color: #333;
            line-height: 15px;
            margin: 0;
          }
        }

        img {
          width: 27.5px;
          height: 24px;
          position: relative;
          right: 15px;
        }
      }

      .middle {
        flex: 0 0 1px;
        height: 26px;
        margin: 0 12px;
        background-color: #ccc;
      }

      .right {
        flex: 0 0 40%;
        text-align: left;

        h3 {
          font-size: 11px;
          font-weight: 600;
          color: #999;
          line-height: 15px;
          margin: 0;
        }
      }
    }

    .love_title {
      font-size: 11px;
      font-weight: 400;
      line-height: 16px;
      color: #999;
      padding: 0 20px;
    }

    .footer_log {
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;
      margin: 15px auto 5px;

      img {
        height: 18px;
      }

      .left {
        flex: 0 0 40%;
        text-align: right;
      }

      .middle {
        flex: 0 0 28px;
      }

      .right {
        flex: 0 0 40%;
        text-align: left;
      }
    }
  }

  .footer-copyright {
    border-top: 1px solid #e6e8e8;
    padding: 15px 0;
    font-size: 13px;
    color: #999;
    background-color: #fff;

    .container {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;

      .guide {
        text-align: left;

        .list {
          display: flex;
          justify-content: space-between;
          p {
            margin: 8px 0 11px 0;
            a {
              cursor: pointer;
              text-decoration: none;
              color: #d13c3c;
            }
          }
        }
      }

      .service {
        position: relative;
        font-size: 28px;
        text-align: right;
        color: #d13c3c;
        p {
          margin: 0;
          font-size: 13px;
          color: #999;
        }
      }
    }
  }
}

.qsgy-dialog {
  .title {
    color: #d13c3c;
    margin-bottom: 35px;
  }

  .el-dialog__body {
    padding: 10px 20px;

    .el-textarea__inner:focus {
      border-color: #d13c3c;
    }

    .textarea-bt-38 {
      margin-bottom: 25px;
      position: relative;
    }

    .item-group {
      .label {
        font-weight: 600;
        margin-bottom: 15px;
        font-size: 14px;
      }
      .topic {
        font-size: 14px;
      }
    }

    .error-info {
      height: 20px;
      position: relative;
      margin-bottom: 15px;
    }

    .error-tips {
      font-size: 12px;
      color: #ed2424;
    }
  }

  /deep/.el-message {
    top: 50% !important;
  }
}
</style>
